/**
 * Verification scoring thresholds and states.
 * These control how daily reports are scored and flagged.
 */
export const VERIFICATION_THRESHOLDS = {
    GREEN: 70, // >= 70% = verified green
    YELLOW: 50, // >= 50% = verified yellow
    RED: 0, // < 50% = flagged red
};
export const VERIFICATION_STATES = {
    PENDING: 'pending',
    VERIFIED_GREEN: 'verified_green',
    VERIFIED_YELLOW: 'verified_yellow',
    FLAGGED_RED: 'flagged_red',
    REVERIFIED: 'reverified',
    MANUALLY_REVIEWED: 'manually_reviewed',
    MISSING: 'missing',
};
export const EMPLOYEE_MODES = {
    ENGINEERING: 'engineering', // Auto-verified via GitHub/JIRA
    STANDARD: 'standard', // Manual review by manager
};
export const LLM_TIERS = {
    ROUTINE: 'haiku', // Routine verification
    COMPLEX: 'sonnet', // Complex analysis
    DEEP: 'opus', // Deep review / performance analysis
};
export const VERIFICATION_SCHEDULE = {
    WEEKLY_DAY: 1, // Monday
    WEEKLY_HOUR: 12, // 12:00
    MONTHLY_DAY: 1, // 1st of month
    MONTHLY_HOUR: 12, // 12:00
    TIMEZONE: 'Asia/Tokyo',
};
export const CONFIDENCE_SCORE = {
    MIN: 0,
    MAX: 100,
    HIGH_RISK_THRESHOLD: 30,
};
/** Claude model version mapping per LLM tier */
export const CLAUDE_MODELS = {
    [LLM_TIERS.ROUTINE]: 'claude-haiku-4-5-20251001',
    [LLM_TIERS.COMPLEX]: 'claude-sonnet-4-6-20250514',
    [LLM_TIERS.DEEP]: 'claude-opus-4-6-20250918',
};
/** Per-model pricing (USD per 1M tokens) */
export const CLAUDE_PRICING = {
    [LLM_TIERS.ROUTINE]: { inputPer1M: 0.8, outputPer1M: 4.0 },
    [LLM_TIERS.COMPLEX]: { inputPer1M: 3.0, outputPer1M: 15.0 },
    [LLM_TIERS.DEEP]: { inputPer1M: 15.0, outputPer1M: 75.0 },
};
/** Compliance thresholds — below these rates triggers manager alerts */
export const COMPLIANCE_THRESHOLDS = {
    ALERT: 80, // Below 80% triggers manager alert
    CRITICAL: 50, // Below 50% triggers escalation
};
export const NOTIFICATION_TYPES = {
    RED_FLAG_ALERT: 'red_flag_alert',
    WEEKLY_SUMMARY: 'weekly_summary',
    COMPLIANCE_ALERT: 'compliance_alert',
};
/** Schedule config for automated notifications (UTC) */
export const NOTIFICATION_SCHEDULE = {
    WEEKLY_SUMMARY_DAY: 1, // Monday
    WEEKLY_SUMMARY_HOUR_UTC: 3, // 03:30 UTC → 12:30 JST
    WEEKLY_SUMMARY_MINUTE: 30,
    COMPLIANCE_CALC_DAY: 1, // 1st of month
    COMPLIANCE_CALC_HOUR_UTC: 4, // 04:00 UTC → 13:00 JST
    RED_FLAG_SLA_MINUTES: 60, // Must send within 60 minutes
};
const TOKENS_PER_MILLION = 1_000_000;
/** Estimate cost in USD from token usage */
export const estimateCost = (tier, inputTokens, outputTokens) => {
    const pricing = CLAUDE_PRICING[tier];
    return ((inputTokens / TOKENS_PER_MILLION) * pricing.inputPer1M +
        (outputTokens / TOKENS_PER_MILLION) * pricing.outputPer1M);
};
//# sourceMappingURL=verification.js.map